import React from 'react';
import ReactDOM from 'react-dom/client';
import { applyTheme, getStoredTheme } from './lib/theme';
import App from './App';

applyTheme(getStoredTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
